'use strict';

module.exports = Object.prototype.toString;